export enum MyProvidersStatus {
  NotStarted = 'Not Started',
  Started = 'Started',
  UnderReview = 'Under Review',
  Active = 'Active',
  Inactive = 'Inactive',
  Submitted = 'Submitted'
}
